import validate from "/work/release/fe-oj-monorepo-hetao/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@20.19.25_db0@0.3.4_eslint@9.39.1_jiti@2.6.1__io_2i5jmtfny4kok2wdv4tm26va6q/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/work/release/fe-oj-monorepo-hetao/packages/core/middleware/auth.global.ts";
import manifest_45route_45rule from "/work/release/fe-oj-monorepo-hetao/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@20.19.25_db0@0.3.4_eslint@9.39.1_jiti@2.6.1__io_2i5jmtfny4kok2wdv4tm26va6q/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "force-default-layout": () => import("/work/release/fe-oj-monorepo-hetao/packages/core/middleware/force-default-layout.ts"),
  "galaxy-access": () => import("/work/release/fe-oj-monorepo-hetao/packages/core/middleware/galaxy-access.ts"),
  home: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/middleware/home.ts")
}